var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
export var TabActiveProp = "active";
var active = TabActiveProp;
var blocksAttr = "data-tab-block";
var triggersAttr = "data-tab-trigger";
/**
 * Tabs draws and animates tabs on the page.
 *
 */
/* EXAMPLE USAGE:
    <Tabs>
        <TabsTriggers>
            <TabTrigger link="tab1-id">Trigger 1</TabTrigger>
            <TabTrigger link="tab2-id" default={true}>Trigger 2</TabTrigger>
            <TabTrigger link="tab3-id">Trigger 3</TabTrigger>
            <TabTrigger link="tab4-id" disabled={true}>Trigger 4</TabTrigger>
        </TabsTriggers>
        <TabsBlocks>
            <TabBlock link="tab1-id">
                {this.state.prop}
            </TabBlock>
            <TabBlock link="tab2-id">
                Other Content for tab 2<br /> something else<br /> something else
            </TabBlock>
            <TabBlock link="tab3-id">
                Content for tab 3<br /> something else
            </TabBlock>
        </TabsBlocks>
    </Tabs>
*/
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.blocks = [];
        _this.triggers = [];
        return _this;
    }
    /**
     * registerNodes creates arrays from the triggers and blocks in order to control them easier. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.registerNodes = function (n) {
        if (n !== null) {
            this.blocks = Array.prototype.slice.call(n.querySelectorAll("[" + blocksAttr + "]"));
            this.triggers = Array.prototype.slice.call(n.querySelectorAll("[" + triggersAttr + "]"));
        }
    };
    /**
     * resetElements hides what is shown whenever a different tab is selected. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.resetElements = function (arr, type) {
        arr
            .filter(function (x) { return x.dataset[type] === active; })
            .forEach(function (x) {
            typeof x["hide"] === "function" && x["hide"]();
            x.dataset[type] = "true";
        });
    };
    /**
     *  deselectPair. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.deselectPair = function () {
        this.resetElements(this.blocks, "tabBlock");
        this.resetElements(this.triggers, "tabTrigger");
    };
    /**
     *  selectPair. Ignored during code coverage tests as it requires browser testing.
     * @param {i} Number index of the item that needs to be selected
     */
    // TODO(developer): simplify and split
    /* istanbul ignore next */
    Tabs.prototype.selectPair = function (i) {
        this.deselectPair();
        if (typeof i === "string") {
            var b = this.blocks.filter(function (x) { return x.dataset.tabLink === i; })[0];
            typeof b["show"] === "function" && b["show"]();
            var t = this.triggers.filter(function (x) { return x.dataset.tabLink === i; })[0];
            b.dataset.tabBlock = active;
            t.dataset.tabTrigger = active;
        }
        if (typeof i === "number" && this.blocks[i]) {
            typeof this.blocks[i]["show"] === "function" && this.blocks[i]["show"]();
            this.blocks[i].dataset.tabBlock = active;
            this.triggers[i].dataset.tabTrigger = active;
        }
    };
    /**
     *  getDefault reads for default attriute added. If non added, returns 0 which is the index of the first pair. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.getDefault = function () {
        var d = this.triggers.indexOf(this.triggers.filter(function (x) { return x.dataset.tabDefault; })[0]);
        return d >= 0 ? d : 0;
    };
    /**
     *  componentDidMount marks the default pair. If non detected, marks the first index, which is 0 Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.componentDidMount = function () {
        this.resetTabs();
    };
    /**
     *  resetTabs. Callable from the outside to force refresh. Not recomended.
     */
    /* istanbul ignore next */
    Tabs.prototype.resetTabs = function () {
        this.selectPair(this.getDefault());
    };
    /**
     * onClick. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Tabs.prototype.onClick = function (e) {
        var t = e.target;
        // cases where triggers are wrapped and user didn't click on the tab
        // handles edge cases
        if (typeof t.dataset.tabTrigger === "undefined") {
            t = t.closest("[" + triggersAttr + "]") || e.target.querySelector("[" + triggersAttr + "]");
        }
        if (t &&
            t.dataset.tabTrigger &&
            t.dataset.tabTrigger !== active &&
            t.dataset.tabTrigger !== "false") {
            var i = t.dataset.tabLink || this.triggers.indexOf(t);
            this.selectPair(i);
        }
    };
    Tabs.prototype.render = function () {
        var _this = this;
        return (React.createElement("sb-tabs", { ref: function (n) { return _this.registerNodes(n); }, onClick: this.onClick.bind(this) }, this.props.children));
    };
    return Tabs;
}(React.Component));
export { Tabs };
//# sourceMappingURL=Tabs.js.map